
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Ja – und auch hier kommt wieder das luzide Träumen ins Spiel. Dieses kann gezielt zur Selbstoptimierung genutzt werden. An der Uni Bern befasst sich der Wissenschaftler Daniel Erlacher mit Klarträumen und deren Anwendung im Sport. `}<M mdxType="M">{`Wer seine Träume steuern lernt, könne während des Schlafs bestimmte Bewegungsabläufe trainieren und so seine Leistung steigern.`}</M>{` «Aus Studien wissen wir, dass sich zum Beispiel das Dartspielen am nächsten Tag verbessert, wenn man im Traum trainiert», sagt Erlacher. Üben im Schlaf habe ähnlich starke Effekte wie das reale Üben. Noch ist der Einsatz von Klarträumen kein Standard, aber manch ein Profisportler nutzt diese Möglichkeit bereits.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;